import React from "react";

// import ReactPlayer from 'react-player';
const ReactPlayer =
  typeof window !== "undefined"
    ? require("react-player").default
    : () => <div />;

const VideoBlock = ({ block }) => {
  const platform = block.videoType;
  let baseUrl = null;
  switch (platform) {
    case "YouTube":
      baseUrl = "https://www.youtube.com/embed/";
      break;
    case "Vimeo":
      baseUrl = "https://vimeo.com/";
      break;
  }

  return (
    <div className="video-block__container w-100 mw-696 mv2 mv3-l">
      <ReactPlayer
        url={`${baseUrl}${block.embedCode}`}
        controls
        width="100%"
        height="100%"
        className="video-block__embed"
      />
      {block.caption && (
        <p className="video-block__caption caption grey1 mt1 db">
          {block.caption}
        </p>
      )}
    </div>
  );
};

export default VideoBlock;



// WEBPACK FOOTER //
// ./src/components/Blocks/VideoBlock.js